<section>
    <div id="prueba">
        <h1 class="centrado4 rounded eventosTitulo" ><strong>Eventos</strong></h1>
    </div>
</section>
<section class="container-fluid ciudadCARD">
    <div class="row ">
        <div class=" col-0 col-sm-1 d-md-none"></div>
        <div class="mt-3 col-12 col-sm-10  col-md-6   col-lg-4 col-xl-3 contenedor8"  style="height: 400px" *ngFor="let evento of eventos">
            <div class=" border rounded ciudadCARDin">
                <div class="contenedor contenedor2" >
                    <img *ngIf="evento.soldout" class="sold_out"src="../../assets/images/img/SOLDOUT.png" alt="">  
                    <a routerLink="/eventos/evento/{{evento.id}}" class="outerLink"> 
                        <img *ngIf="evento.imagen" src="{{evento.imagen.url}}" class=" rounded  darkableImage"onmouseout="javascript:this.style.opacity=1;javascript:this.opacity=1" 
                        onmouseover="javascript:this.style.opacity=0.4;this.opacity=40" />
                    </a>
                    <p  class="centrado2"><strong> {{evento?.descripcion|resumir2}}</strong></p>
                </div>
            </div>
            <div class="border rounded container-fluid ciudadCARDin2" >
                <div class="row contenedor contenedorBot" >
                    <div class="col-12" >
                        <h2 class=" rounded titulos pt-3 pr-3 pl-3"  ><strong> <a class="titulos" routerLink="/eventos/evento/{{evento.id}}">{{evento?.nombre }}</a></strong></h2> 
                        <hr class="aaa" >
                    </div>
                    <div class="col-6 border-right fechaCiudad">
                        <p class="fechas"><strong>{{evento?.fecha|date}} </strong></p>
                    </div>
                    <div class="col-6 botonVer">
                        <button *ngIf="!evento.soldout" class="action_button rounded-pill shadow texto bg-darkblue-gradient"
                        routerLink="/eventos/evento/{{evento.id}}">Comprar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-0 col-sm-1 d-md-none"></div>
    </div>
</section>

 


